module.exports = __webpack_public_path__ + "img/PrimeroExpressLogo.e004e243.png";